import {css} from "@emotion/react";
import React from "react";
import {Card} from "../../../TabsRoute/components/Card";
import {Typography} from "../../../Typography";

import {BingMaps} from "./../BingMaps"
import {MapSvg} from "./components/MapSvg";
import {title} from "./styles";
import {RawSite} from "../../../../sdk/queries/types";
import {AllLocations_Location} from "../../../../sdk/queries";

export const MapCard: React.FC<{location: AllLocations_Location | undefined;}> = ({
    location
}) => {

    return <Card padding={0} wrapperCss={css({
        minHeight: 500,
    })}>
        <div css={title}>
            <Typography variant={"h3"} leftIcon={<MapSvg/>}>Map</Typography>
        </div>
        <BingMaps title = {location?.name} latitude = {location?.latitude} longitude = {location?.longitude} >

        </BingMaps>
    </Card>
};
